import { isHarmonyThemeId } from '@office-start/theming-service';
import { constructCdnUrl } from '@office-start/url-parser-utility';
var themeIdMap = {
    Office: 'default',
    M365Default: 'm365default',
};
var themeModeMap = {
    default: 'light',
    dark: 'dark',
};
export var getVisualBackgroundImageURL = function (themeId, themeMode, cdnDomain, visualBackgroundGradientEnabled, m365DefaultThemeEnabled) {
    if (!themeIdMap[themeId] || !themeModeMap[themeMode]) {
        return undefined;
    }
    // when m365DefaultThemeEnabled flight is enabled, show the new m365default image when in default theme, currently only available for lightmode.
    var themeImageName = m365DefaultThemeEnabled && isHarmonyThemeId(themeId)
        ? themeIdMap['M365Default']
        : themeIdMap[themeId];
    return constructCdnUrl(cdnDomain, 'officestartresources', "visual_background_".concat(themeImageName, "_").concat(themeModeMap[themeMode]).concat(visualBackgroundGradientEnabled ? '_new' : ''), 'jpg');
};
//# sourceMappingURL=getVisualBackgroundImageURL.js.map